/**
 * Glyphs dropped along the cursor path by CursorTrailLayer. ONE generic set
 * for every restaurant: the trail was first a hard-coded sushi set, then a
 * per-cuisine table — both made the page guess what the kitchen serves, and
 * both ended up wrong somewhere. Neutral symbols read the same everywhere.
 */
export const TRAIL_GLYPHS: readonly string[] = ['✨', '🍽️', '😋', '🍴', '⭐'];
